import React from "react";
import type { CaseStudy } from "../content/cases";

function CaseCard({ study }: { study: CaseStudy }) {
  return (
    <article className="case-card" id={study.slug}>
      <div className="case-cover">
        <img src={study.image} alt={study.client} loading="lazy" />
        <span className="case-brand">{study.client}</span>
      </div>

      <div className="case-content">
        <div className="case-title-row">
          <h2 className="case-title">{study.title}</h2>
          <span className={`status-pill status-${study.status}`}>
            {study.status === "ongoing" ? "Ongoing" : "Delivered"}
          </span>
        </div>

        <p className="case-summary">{study.summary}</p>

        <details className="case-details">
          <summary className="case-toggle">
            <span className="case-toggle-more">Read the full story</span>
            <span className="case-toggle-less">Show less</span>
          </summary>
          <div className="case-body">
            {study.body.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </details>

        <ul className="tag-list case-tags">
          {study.tags.map((tag) => (
            <li key={tag} className="tag">
              {tag}
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}

export default CaseCard;
